import { Box, Grid2 as Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Features as FeaturesEnum } from "../../enums";
import {
  useUpdateOrganizationFeatureFlagMutation,
  useFetchOrganizationFeaturesQuery,
} from "../../api";
import { useAtom } from "jotai";
import { selectedOrgIdAtom, toastOptionsAtom } from "../../atoms";

export const Features = () => {
  const [kpiAdminReport, setKpiAdminReport] = useState(false);
  const [, setToastOptions] = useAtom(toastOptionsAtom);
  const [selectedOrgId] = useAtom(selectedOrgIdAtom);
  const updateOrganizationFeatureFlagMutation =
    useUpdateOrganizationFeatureFlagMutation();
  const fetchOrganizationFeaturesQuery = useFetchOrganizationFeaturesQuery(
    selectedOrgId,
    {
      enabled: selectedOrgId ? true : false,
    },
  );
  const [dashboard, setDashboard] = useState(false);

  useEffect(() => {
    if (fetchOrganizationFeaturesQuery.isSuccess) {
      localStorage.setItem(
        `organizationFeatures_${selectedOrgId}`,
        JSON.stringify(fetchOrganizationFeaturesQuery.data),
      );

      const kpiFeature = fetchOrganizationFeaturesQuery.data.find(
        (item) => item.feature === FeaturesEnum.KPI_REPORT,
      );

      setKpiAdminReport(kpiFeature?.enabled || false);
      const dashboardFeature = fetchOrganizationFeaturesQuery.data.find(
        (item) => item.feature === FeaturesEnum.DASHBOARD,
      );

      setDashboard(dashboardFeature?.enabled || false);
    }
  }, [
    fetchOrganizationFeaturesQuery.isSuccess,
    fetchOrganizationFeaturesQuery.isError,
    fetchOrganizationFeaturesQuery.data,
    fetchOrganizationFeaturesQuery.error,
    fetchOrganizationFeaturesQuery.isLoading,
  ]);

  useEffect(() => {
    if (updateOrganizationFeatureFlagMutation.isSuccess) {
      setToastOptions({
        open: true,
        message: "Feature flag updated successfully.",
        severity: "success",
      });
      fetchOrganizationFeaturesQuery.refetch();
    } else if (updateOrganizationFeatureFlagMutation.isError) {
      setToastOptions({
        open: true,
        message: "Failed to update feature flag.",
        severity: "error",
      });
    }
  }, [
    updateOrganizationFeatureFlagMutation.isSuccess,
    updateOrganizationFeatureFlagMutation.isError,
    updateOrganizationFeatureFlagMutation.isLoading,
    updateOrganizationFeatureFlagMutation.data,
    updateOrganizationFeatureFlagMutation.error,
  ]);

  return (
    <Grid
      container
      direction={"row"}
      spacing={3}
      gap={3}
      sx={{
        direction: "row",
        borderRadius: "10px",
        px: "4px",
      }}
    >
      <Grid size={12}>
        <Box
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: "12px",
            p: 3,
            height: "100%",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography variant="body1">KPI Admin Report</Typography>

            <Switch
              checked={kpiAdminReport}
              onChange={(e) => {
                const enabled = e.target.checked;
                updateOrganizationFeatureFlagMutation.mutate({
                  orgId: selectedOrgId,
                  feature: FeaturesEnum.KPI_REPORT,
                  enabled,
                });
              }}
              size="small"
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mt: 2,
            }}
          >
            <Typography variant="body1">Dashboard</Typography>

            <Switch
              checked={dashboard}
              onChange={(e) => {
                const enabled = e.target.checked;

                updateOrganizationFeatureFlagMutation.mutate({
                  orgId: selectedOrgId,
                  feature: FeaturesEnum.DASHBOARD,
                  enabled,
                });
              }}
              size="small"
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
